import state from './user_state.js'
import mutations from './user_mutations.js'
import actions from './user_actions.js'
import getters from './user_getters.js'

export default {
    name: 'user',
    persistence: {
        type: 'localStorage'
    },
    auth: {
        require: true,
        hooks: {
            // refresh: 'user/fetchProfile',
            // login: 'user/fetchProfile'
        }
    },
    state,
    mutations,
    actions,
    getters
}
